import React from "react";
import { useState } from "react";

import styles from "../../../styles/__labChatList.module.scss";
import LabDashboardLayout from "../../../components/labmod-dashboard-layout/LabModDashboardLayout";
import { ChevronRight, Phone, Mail } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { BsChatText } from "react-icons/bs";

const ChatList = ({ onLogout, onNavigateToDashboard }) => {
  const [notificationEnabled, setNotificationEnabled] = useState(true);
  const { t, i18n } = useTranslation();
  const DisplayLanguageIcon = () => (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_2651_21716)">
        <mask
          id="mask0_2651_21716"
          style={{ maskType: "luminance" }}
          maskUnits="userSpaceOnUse"
          x="0"
          y="0"
          width="25"
          height="24"
        >
          <path d="M24.4297 0H0.429688V24H24.4297V0Z" fill="white" />
        </mask>
        <g mask="url(#mask0_2651_21716)">
          <path
            d="M15.2187 19.4203C15.1087 19.4203 14.9887 19.3904 14.8887 19.3404C14.5187 19.1504 14.3687 18.7004 14.5487 18.3304L16.6887 14.0604C16.8187 13.8104 17.0787 13.6504 17.3587 13.6504C17.6387 13.6504 17.8987 13.8104 18.0287 14.0704L20.1687 18.3404C20.3587 18.7104 20.2087 19.1603 19.8287 19.3503C19.4587 19.5403 19.0087 19.3904 18.8187 19.0104L17.3587 16.0804L15.8987 19.0104C15.7587 19.2704 15.4887 19.4203 15.2187 19.4203Z"
            fill="#2D2D37"
          />
          <path
            d="M19.1097 18.6602H15.5898C15.1798 18.6602 14.8398 18.3202 14.8398 17.9102C14.8398 17.5002 15.1798 17.1602 15.5898 17.1602H19.1097C19.5197 17.1602 19.8597 17.5002 19.8597 17.9102C19.8597 18.3202 19.5297 18.6602 19.1097 18.6602Z"
            fill="#2D2D37"
          />
          <path
            d="M17.3495 22.7498C14.1395 22.7498 11.5195 20.1398 11.5195 16.9198C11.5195 13.6998 14.1295 11.0898 17.3495 11.0898C20.5595 11.0898 23.1795 13.6998 23.1795 16.9198C23.1795 20.1398 20.5695 22.7498 17.3495 22.7498ZM17.3495 12.5998C14.9595 12.5998 13.0195 14.5398 13.0195 16.9298C13.0195 19.3198 14.9595 21.2598 17.3495 21.2598C19.7295 21.2598 21.6795 19.3198 21.6795 16.9298C21.6795 14.5398 19.7395 12.5998 17.3495 12.5998Z"
            fill="#2D2D37"
          />
          <path
            d="M5.28969 12.7003C4.17969 12.7003 3.29969 12.3902 2.67969 11.7902C2.01969 11.1502 1.67969 10.1802 1.67969 8.93024V5.01025C1.67969 2.58025 3.01969 1.24023 5.44969 1.24023H9.36969C10.6197 1.24023 11.5797 1.57023 12.2297 2.24023C12.8597 2.89023 13.1697 3.83027 13.1397 5.03027V8.93024C13.1697 10.1502 12.8597 11.1103 12.2097 11.7603C11.5597 12.4103 10.5997 12.7102 9.35968 12.6902H5.45969C5.38969 12.7002 5.33969 12.7003 5.28969 12.7003ZM5.44969 2.75024C3.83969 2.75024 3.17969 3.41026 3.17969 5.02026V8.94025C3.17969 9.77026 3.35968 10.3702 3.71968 10.7202C4.06968 11.0602 4.6297 11.2103 5.4197 11.2003H9.35968C10.1997 11.2203 10.7797 11.0503 11.1297 10.7003C11.4797 10.3503 11.6397 9.76026 11.6197 8.95026V5.01025C11.6397 4.21025 11.4797 3.64022 11.1397 3.29022C10.7897 2.93022 10.1897 2.75024 9.35968 2.75024H5.44969Z"
            fill="#2D2D37"
          />
          <path
            d="M9.43109 6.59961H5.37109C4.96109 6.59961 4.62109 6.25961 4.62109 5.84961C4.62109 5.43961 4.96109 5.09961 5.37109 5.09961H9.43109C9.84109 5.09961 10.1811 5.43961 10.1811 5.84961C10.1811 6.25961 9.85109 6.59961 9.43109 6.59961Z"
            fill="#2D2D37"
          />
          <path
            d="M7.41016 6.59991C7.00016 6.59991 6.66016 6.25991 6.66016 5.84991V5.16992C6.66016 4.75992 7.00016 4.41992 7.41016 4.41992C7.82016 4.41992 8.16016 4.75992 8.16016 5.16992V5.84991C8.16016 6.25991 7.82016 6.59991 7.41016 6.59991Z"
            fill="#2D2D37"
          />
          <path
            d="M5.37109 9.75983C4.96109 9.75983 4.62109 9.41983 4.62109 9.00983C4.62109 8.59983 4.96109 8.25983 5.37109 8.25983C6.64109 8.25983 7.67109 7.17984 7.67109 5.83984C7.67109 5.42984 8.01109 5.08984 8.42109 5.08984C8.83109 5.08984 9.17109 5.42984 9.17109 5.83984C9.17109 7.99984 7.47109 9.75983 5.37109 9.75983Z"
            fill="#2D2D37"
          />
          <path
            d="M9.4401 9.76007C8.5101 9.76007 7.62011 9.29008 6.99011 8.46008C6.74011 8.13008 6.81012 7.66003 7.14012 7.41003C7.47012 7.16003 7.9401 7.23005 8.1901 7.56005C8.5301 8.02005 8.9801 8.27008 9.4401 8.27008C9.8501 8.27008 10.1901 8.61008 10.1901 9.02008C10.1901 9.43008 9.8501 9.76007 9.4401 9.76007Z"
            fill="#2D2D37"
          />
          <path
            d="M9.42969 22.75C5.15969 22.75 1.67969 19.27 1.67969 15C1.67969 14.59 2.01969 14.25 2.42969 14.25C2.83969 14.25 3.17969 14.59 3.17969 15C3.17969 17.96 5.23969 20.44 8.00969 21.09L7.73969 20.64C7.52969 20.28 7.6397 19.82 7.9997 19.61C8.3497 19.4 8.8197 19.51 9.0297 19.87L10.0797 21.62C10.2197 21.85 10.2197 22.14 10.0897 22.37C9.94969 22.6 9.69969 22.75 9.42969 22.75Z"
            fill="#2D2D37"
          />
          <path
            d="M22.4282 9.75C22.0182 9.75 21.6782 9.41 21.6782 9C21.6782 6.04 19.6182 3.55997 16.8482 2.90997L17.1182 3.35999C17.3282 3.71999 17.2182 4.18001 16.8582 4.39001C16.5082 4.60001 16.0382 4.49001 15.8282 4.13L14.7782 2.38C14.6382 2.15 14.6382 1.86 14.7682 1.63C14.8982 1.39 15.1482 1.25 15.4182 1.25C19.6882 1.25 23.1682 4.73 23.1682 9C23.1782 9.41 22.8382 9.75 22.4282 9.75Z"
            fill="#2D2D37"
          />
        </g>
      </g>
      <defs>
        <clipPath id="clip0_2651_21716">
          <rect
            width="24"
            height="24"
            fill="white"
            transform="translate(0.429688)"
          />
        </clipPath>
      </defs>
    </svg>
  );

  const NotificationIcon = () => (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4278 1.25C10.3724 1.25 8.40113 2.06652 6.94772 3.51992C5.49431 4.97333 4.6778 6.94457 4.6778 9V9.704C4.67774 10.4009 4.47141 11.0822 4.0848 11.662L2.9378 13.385C1.6038 15.385 2.6218 18.103 4.9408 18.735C5.69613 18.941 6.45746 19.1153 7.2248 19.258L7.2268 19.263C7.9948 21.315 10.0498 22.75 12.4278 22.75C14.8058 22.75 16.8608 21.315 17.6298 19.263L17.6318 19.258C18.3999 19.1145 19.1618 18.94 19.9158 18.735C22.2348 18.103 23.2528 15.385 21.9188 13.385L20.7708 11.662C20.3842 11.0822 20.1779 10.4009 20.1778 9.704V9C20.1778 6.94457 19.3613 4.97333 17.9079 3.51992C16.4545 2.06652 14.4832 1.25 12.4278 1.25ZM15.8038 19.537C13.5608 19.8046 11.2938 19.8046 9.0508 19.537C9.7618 20.558 10.9988 21.25 12.4278 21.25C13.8568 21.25 15.0928 20.558 15.8038 19.537ZM6.1778 9C6.1778 7.3424 6.83628 5.75269 8.00838 4.58058C9.18048 3.40848 10.7702 2.75 12.4278 2.75C14.0854 2.75 15.6751 3.40848 16.8472 4.58058C18.0193 5.75269 18.6778 7.3424 18.6778 9V9.704C18.6778 10.697 18.9718 11.668 19.5228 12.494L20.6708 14.217C20.8487 14.4834 20.9607 14.7883 20.9975 15.1065C21.0343 15.4247 20.9949 15.7471 20.8826 16.0471C20.7703 16.3471 20.5882 16.6161 20.3514 16.8319C20.1146 17.0476 19.8299 17.204 19.5208 17.288C14.8766 18.5546 9.97799 18.5546 5.3338 17.288C5.02483 17.2039 4.74028 17.0476 4.50362 16.8319C4.26696 16.6162 4.08496 16.3473 3.97263 16.0475C3.86031 15.7476 3.82088 15.4254 3.85759 15.1073C3.89431 14.7892 4.00612 14.4844 4.1838 14.218L5.3338 12.494C5.88434 11.6677 6.178 10.6969 6.1778 9.704V9Z"
        fill="#2D2D37"
      />
    </svg>
  );

  const UserIcon = () => (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.2501 6C15.2501 4.20507 13.795 2.75 12.0001 2.75C10.2051 2.75 8.75006 4.20507 8.75006 6C8.75006 7.79493 10.2051 9.25 12.0001 9.25C13.795 9.25 15.2501 7.79493 15.2501 6ZM16.7501 6C16.7501 8.62335 14.6234 10.75 12.0001 10.75C9.37671 10.75 7.25006 8.62335 7.25006 6C7.25006 3.37665 9.37671 1.25 12.0001 1.25C14.6234 1.25 16.7501 3.37665 16.7501 6Z"
        fill="#2D2D37"
      />
      <path
        d="M19.25 17.5C19.25 16.6488 18.6286 15.7252 17.2891 14.9717C15.9731 14.2314 14.1046 13.75 12 13.75C9.89547 13.75 8.02695 14.2314 6.71095 14.9717C5.3714 15.7252 4.75001 16.6488 4.75001 17.5C4.75001 18.8076 4.79035 19.5441 5.47365 20.1006C5.84415 20.4023 6.46356 20.6965 7.52345 20.9111C8.58039 21.1251 10.0258 21.25 12 21.25C13.9742 21.25 15.4196 21.1251 16.4766 20.9111C17.5365 20.6965 18.1559 20.4023 18.5264 20.1006C19.2097 19.5441 19.25 18.8076 19.25 17.5ZM20.75 17.5C20.75 18.6774 20.7904 20.1914 19.4736 21.2637C18.8442 21.7762 17.9631 22.141 16.7734 22.3818C15.5805 22.6233 14.0255 22.75 12 22.75C9.97448 22.75 8.41957 22.6233 7.22657 22.3818C6.0369 22.141 5.15584 21.7762 4.52638 21.2637C3.20967 20.1914 3.25001 18.6774 3.25001 17.5C3.25001 15.8662 4.41965 14.5393 5.9756 13.6641C7.55507 12.7756 9.68667 12.25 12 12.25C14.3134 12.25 16.445 12.7756 18.0244 13.6641C19.5804 14.5393 20.75 15.8662 20.75 17.5Z"
        fill="#2D2D37"
      />
    </svg>
  );

  const ChatWithAdmin = () => (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.4297 2.75C9.97645 2.75 7.62367 3.72455 5.88896 5.45926C4.15425 7.19397 3.1797 9.54675 3.1797 12C3.1797 13.481 3.5277 14.879 4.1447 16.118C4.3927 16.616 4.4877 17.21 4.3317 17.795L3.7357 20.02C3.71067 20.1132 3.71062 20.2114 3.73555 20.3046C3.76047 20.3979 3.8095 20.4829 3.87769 20.5512C3.94589 20.6195 4.03086 20.6687 4.12407 20.6937C4.21728 20.7188 4.31544 20.7189 4.4087 20.694L6.6357 20.098C7.19846 19.9537 7.79458 20.0202 8.3117 20.285C9.59079 20.9221 11.0007 21.2525 12.4297 21.25C14.883 21.25 17.2357 20.2754 18.9704 18.5407C20.7051 16.806 21.6797 14.4533 21.6797 12C21.6797 9.54675 20.7051 7.19397 18.9704 5.45926C17.2357 3.72455 14.883 2.75 12.4297 2.75ZM1.6797 12C1.6797 6.063 6.4927 1.25 12.4297 1.25C18.3667 1.25 23.1797 6.063 23.1797 12C23.1797 17.937 18.3667 22.75 12.4297 22.75C10.7117 22.75 9.0857 22.346 7.6427 21.628C7.45223 21.5281 7.23228 21.4997 7.0227 21.548L4.7967 22.143C3.2727 22.551 1.8787 21.157 2.2867 19.633L2.8827 17.407C2.93097 17.1974 2.90259 16.9775 2.8027 16.787C2.06184 15.3001 1.67736 13.6612 1.6797 12ZM7.6797 10.5C7.6797 10.3011 7.75872 10.1103 7.89937 9.96967C8.04002 9.82902 8.23079 9.75 8.4297 9.75H16.4297C16.6286 9.75 16.8194 9.82902 16.96 9.96967C17.1007 10.1103 17.1797 10.3011 17.1797 10.5C17.1797 10.6989 17.1007 10.8897 16.96 11.0303C16.8194 11.171 16.6286 11.25 16.4297 11.25H8.4297C8.23079 11.25 8.04002 11.171 7.89937 11.0303C7.75872 10.8897 7.6797 10.6989 7.6797 10.5ZM7.6797 14C7.6797 13.8011 7.75872 13.6103 7.89937 13.4697C8.04002 13.329 8.23079 13.25 8.4297 13.25H13.9297C14.1286 13.25 14.3194 13.329 14.46 13.4697C14.6007 13.6103 14.6797 13.8011 14.6797 14C14.6797 14.1989 14.6007 14.3897 14.46 14.5303C14.3194 14.671 14.1286 14.75 13.9297 14.75H8.4297C8.23079 14.75 8.04002 14.671 7.89937 14.5303C7.75872 14.3897 7.6797 14.1989 7.6797 14Z"
        fill="#2D2D37"
      />
    </svg>
  );

  const settingsItems = [
    {
      icon: DisplayLanguageIcon,
      label: "Display Language",
      hasToggle: false,
      hasArrow: true,
    },
    {
      icon: UserIcon,
      label: "My Profile",
      hasToggle: false,
      hasArrow: true,
    },
    {
      icon: ChatWithAdmin,
      label: "Chat with Admin",
      hasToggle: false,
      hasArrow: true,
      link: "/imaging_chat",
    },
  ];

  const contactInfo = [
    {
      icon: Phone,
      label: "Mobile Number",
      value: "+964 770 123 4567",
      type: "phone",
    },
    {
      icon: Mail,
      label: "Email",
      value: "support@tiryaqhealth.iq",
      type: "email",
    },
  ];

  const handleNavigate = (page) => {
    if (page === "dashboard") {
      onNavigateToDashboard();
    }
  };

  const documentRequests = [
    {
      id: 1,
      name: "Abraham James",
      type: "Order ID",
      subType: "Document Request",
      unread: true,
      avatar: "https://i.pravatar.cc/100?img=12",
    },
    {
      id: 2,
      name: "Abraham James",
      type: "Order ID",
      subType: "Document Request",
      unread: true,
      avatar: "https://i.pravatar.cc/100?img=12",
    },
  ];

  const adminChat = {
    id: "admin",
    title: "Chat With Admin",
    subType: "Date",
    unread: true,
  };

  return (
    <>
      <LabDashboardLayout
        currentPage="imaging_chat"
        onNavigate={handleNavigate}
        onLogout={onLogout}
      >
        <div className={styles["settings-container-"]}>
          <div className="">
            <div className="row justify-content-center">
              <div className="col-12 col-lg-12">
                {/* Page Title */}
                <h1 className={styles["settings-title"]}>Chat</h1>

                {/* Settings List */}
                <div
                  className={`${styles["settings-card"]} ${styles["settings-fullCard"]}`}
                >
                  <div className={styles["chatList-wrapper"]}>
                    <div className={styles["inbox"]}>
                      {documentRequests.map((item) => (
                        <div key={item.id} className={styles["inbox-item"]}>
                          <div className={styles["inbox-left"]}>
                            <div>
                              <h4>{item.name}</h4>
                              <p className={styles["inbox-type"]}>
                                {item.type}
                              </p>
                              <p className={styles["inbox-sub"]}>
                                {item.subType}
                              </p>
                            </div>
                          </div>

                          {item.unread && (
                            <span className={styles["inbox-badge"]}>1</span>
                          )}
                        </div>
                      ))}

                      {/* Admin Chat */}
                      <div
                        className={`${styles["inbox-item"]} ${styles["inbox-item-admin"]}`}
                      >
                        <div className={styles["inbox-left"]}>
                          <div className={styles["inbox-icon"]}>
                            <ChatWithAdmin />
                          </div>
                          <div>
                            <h4>{adminChat.title}</h4>
                            <p className={styles["inbox-sub"]}>
                              {adminChat.subType}
                            </p>
                          </div>
                        </div>

                        {adminChat.unread && (
                          <span className={styles["inbox-badge"]}>1</span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Contact Section */}
                  <div className={styles["settings-bottom"]}>
                    <div className={styles["settings-item"]}>
                      <div className={styles["settings-item-left"]}>
                        <ChatWithAdmin className={styles["settings-icon"]} />
                        <span className={styles["settings-label"]}>
                          Chat with Admin
                        </span>
                      </div>

                      <div className={`${styles["settings-item-right"]} `}>
                        <ChevronRight className={styles["settings-arrow"]} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LabDashboardLayout>
    </>
  );
};

export default ChatList;
